import { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
// import { getDeletedThreads, type Thread } from '../../services/MessageService';
import { useNotification } from '../../components/Notifications';
import { useAuth } from '../../security/AuthContext';

// Helper function to format timestamp
const formatTime = (timestamp) => {
  if (!timestamp) {
    console.warn('Timestamp is missing or invalid:', timestamp);
    return 'Unknown';
  }

  try {
    const date = new Date(timestamp);
    if (isNaN(date.getTime())) {
      console.warn('Invalid date parsed from timestamp:', timestamp);
      return 'Unknown';
    }
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  } catch (error) {
    console.error('Error parsing timestamp:', timestamp, error);
    return 'Unknown';
  }
};

const DeletedThreadRow = ({ recipients, subject, createdTs, messages, handleClick, id, user }) => {
  console.log('DeletedThreadRow props:', {
    subject,
    createdTs,
    messages,
    messageCount: Array.isArray(messages) ? messages.length : 0,
    messagesDefined: messages !== undefined && messages !== null,
  });

  const messageCount = Array.isArray(messages) ? messages.length : 0;
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const { addNotification } = useNotification();
  const dropdownRef = useRef(null);

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setIsDropdownOpen(!isDropdownOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleRestore = async (e) => {
    e.stopPropagation();
    addNotification('Restore functionality not implemented', 'warning');
    setIsDropdownOpen(false);
  };

  const handleInvite = (e) => {
    e.stopPropagation();
    setIsDropdownOpen(false);
    const id = e.currentTarget.dataset.id;
    navigate('/messages/participants/' + id);
  };

  return (
    <div
      onClick={handleClick}
      className="flex items-center gap-4 p-2 border-b border-gray-200 cursor-pointer select-none hover:bg-indigo-50"
      role="listitem"
    >
      <div className="flex-1 min-w-0 ml-4">
        <div className="flex items-center gap-2">
          <span className="block font-semibold text-slate-800 max-w-s">{subject}</span>
          <span
            className={`text-xs font-medium ${messageCount >= 1 ? 'text-indigo-600' : 'text-gray-500'}`}
            title={`${messageCount} message${messageCount > 1 ? 's' : ''} in thread`}
          >
            ({messageCount})
          </span>
        </div>
        <span className="block text-slate-600 max-w-lg truncate">
          To: {recipients.map((r) => r.email).join(', ')}
        </span>
      </div>
      <div className="text-sm text-slate-500 whitespace-nowrap ml-8 flex-shrink-0">
        <span>{formatTime(createdTs)}</span>
      </div>
      <div className="relative" ref={dropdownRef}>
        <div className="relative group">
          <button
            className="flex text-indigo-500 h-8 w-8 items-center justify-center rounded-full hover:bg-indigo-600 hover:text-white text-lg cursor-pointer"
            onClick={toggleDropdown}
          >
            <i className="fa-solid fa-ellipsis-v"></i>
          </button>
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 
            hidden group-hover:block bg-indigo-400 text-white text-xs rounded px-2 py-1 z-50 whitespace-nowrap shadow-md">
            More Actions
          </div>
        </div>
        {isDropdownOpen && (
          <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-md shadow-sm z-20">
            <div className="relative group">
              <button
                onClick={handleRestore}
                className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-indigo-50 w-full text-left cursor-pointer"
              >
                <i className="fa-solid fa-undo text-indigo-500"></i>
                Restore
              </button>
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 
                hidden group-hover:block bg-indigo-400 text-white text-xs rounded px-2 py-1 z-50 whitespace-nowrap shadow-md">
                Restore Thread
              </div>
            </div>
            <div className="relative group">
              <button
                data-id={id}
                onClick={handleInvite}
                className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 hover:bg-indigo-50 w-full text-left cursor-pointer"
              >
                <i className="fa-solid fa-user-plus text-indigo-500"></i>
                Invite
              </button>
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 
                hidden group-hover:block bg-indigo-400 text-white text-xs rounded px-2 py-1 z-50 whitespace-nowrap shadow-md">
                Invite To Thread
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export function DeletedThreads() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { addNotification } = useNotification();
  const [searchQuery, setSearchQuery] = useState('');
  const [threads, setThreads] = useState([]);

//   useEffect(() => {
//     loadDeletedThreads();
//   }, []);

//   const loadDeletedThreads = () => {
//     // getDeletedThreads()
//     //   .then((data: Thread[]) => {
//         console.log('Deleted threads data (raw):', data);
//         const uniqueThreads = Array.from(
//           new Map(data.map((thread) => [thread.id, thread])).values()
//         );
//         console.log('Unique deleted threads:', uniqueThreads);
//         uniqueThreads.forEach((t) => {
//           t.recipients = t.recipients.filter((r) => r.email !== user.email);
//           t.messages = t.messages || [];
//         });
//         setThreads(uniqueThreads);
//       })
//       .catch((err) => {
//         addNotification('Error loading deleted threads ' + err.message, 'error');
//       });
//   };

//   const handleThreadClick = (id) => {
//     navigate(`/messages/${id}`);
//   };

//   const handleRefresh = () => {
//     loadDeletedThreads();
//   };

//   const handleSearch = (e) => {
//     setSearchQuery(e.target.value);
//   };

//   const filteredThreads = threads.filter((thread) =>
//     `${thread.recipients.map((r) => r.email).join(' ')} ${thread.subject}`
//       .toLowerCase()
//       .includes(searchQuery.toLowerCase())
//   );

  return (
    <div className="max-w-7xl mx-auto">
      <div className="bg-white shadow-md rounded-lg overflow-visible mb-6">
        <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <h1 className="text-xl font-semibold text-gray-800">Deleted Threads</h1>
            <div className="relative group">
              <button
                className="fa-solid fa-rotate-right flex text-indigo-500 h-8 w-8 items-center justify-center rounded-full hover:bg-indigo-600 hover:text-white text-lg cursor-pointer"
                // onClick={handleRefresh}
              ></button>
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 
                hidden group-hover:block bg-indigo-400 text-white text-xs rounded px-2 py-1 z-50 whitespace-nowrap shadow-md">
                Refresh Deleted Threads
              </div>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <div className="relative group">
              <Link
                to="/messages"
                className="flex text-indigo-500 h-8 w-8 items-center justify-center rounded-full hover:bg-indigo-600 hover:text-white text-sm"
              >
                <i className="fa-solid fa-envelope text-lg"></i>
              </Link>
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 
                hidden group-hover:block bg-indigo-400 text-white text-xs rounded px-2 py-1 z-50 whitespace-nowrap shadow-md">
                Show Threads
              </div>
            </div>
            <div className="relative group">
              <Link
                to="/Archived"
                className="flex text-indigo-500 h-8 w-8 items-center justify-center rounded-full hover:bg-indigo-600 hover:text-white text-sm"
              >
                <i className="fa-solid fa-box-archive text-lg"></i>
              </Link>
              <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 
                hidden group-hover:block bg-indigo-400 text-white text-xs rounded px-2 py-1 z-50 whitespace-nowrap shadow-md">
                Show Archived Threads
              </div>
            </div>
            <div className="relative">
              <input
                type="text"
                value={searchQuery}
                // onChange={handleSearch}
                placeholder="Search deleted threads..."
                className="pr-10 pl-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm text-gray-800 placeholder-gray-400"
              />
              <i
                className="fa-solid fa-magnifying-glass text-indigo-500 absolute right-3 top-1/2 transform -translate-y-1/2 text-lg"
              ></i>
            </div>
          </div>
        </div>
        <div role="list" className="divide-y divide-gray-200">
          {/* {filteredThreads.map((thread) => (
            <DeletedThreadRow
              key={thread.id}
              recipients={thread.recipients}
              subject={thread.subject}
              createdTs={thread.ts}
              messages={thread.messages}
              id={thread.id}
              handleClick={() => handleThreadClick(thread.id)}
              user={user}
            /> */}
          {/* ))} */}
        </div>
      </div>
    </div>
  );
}